import {ContentState} from '../../store';
import {DEFAULT_API_REQ_VALUE, METHOD} from '../constants';

export const initialApiRequestContentState: ContentState = {
  init: false,
  form: {
    method: METHOD.GET,
    url: '',
    value: DEFAULT_API_REQ_VALUE,
  },
  isPreview: false,
  tmpForm: {},
}
